<template>
  <div>
    <v-dialog
      v-model="localDialog"
      max-width="380px"
      transition="dialog-top-transition"
    >
      <v-card class="pa-7">
        <v-card-title class="d-flex justify-center align-center">
          <v-row dense>
            <v-col class="py-0 mb-1" cols="12">
              <span class="icon-background-alert">
                <v-icon dense color="main_red" size="30px" class="my-0">
                  mdi-alert-outline
                </v-icon>
              </span>
            </v-col>
            <v-col cols="12">
              <span>{{ title || $t("deleteQuestion") }}</span>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text class="text-center">
          {{ message || $t("questionTextForDelete") }}
        </v-card-text>

        <v-card-actions class="mb-2">
          <v-row dense>
            <v-col cols="12">
              <v-btn
                block
                depressed
                color="red"
                class="text-color-white"
                @click="confirmDelete"
              >
                {{ confirmText || $t("deleteField") }}
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn
                outlined
                depressed
                color="black"
                block
                @click="closeDialog"
              >
                {{ cancelText || $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DeleteDialog',
  props: {
    dialog: { type: Boolean, default: false },
    itemId: { type: [String, Number], default: null },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    confirmText: { type: String, default: '' },
    cancelText: { type: String, default: '' },
  },
  data () {
    return {
      localDialog: this.dialog,
      localItemId: this.itemId,
    };
  },
  methods: {
    confirmDelete () {
      this.$emit('confirm', this.localItemId);
      this.localDialog = false;
    },
    closeDialog () {
      this.localDialog = false;
      this.$emit('cancel');
    },
  },
  watch: {
    dialog (val) {
      this.localDialog = val;
    },
    localDialog (val) {
      this.$emit('update:dialog', val);
    },
    itemId (val) {
      this.localItemId = val;
    },
  },
};
</script>
